<template>
  <div>
    <tooltip label="View" type="default" placement="left">
      <a class="button is-small" @click="url(this.data)">
        <i class="fa fa-eye"></i>
      </a>
    </tooltip>
  </div>
</template>

<script>
  import Tooltip from 'vue-bulma-tooltip'
  export default {
    data () {
      return {}
    },
    props: {
      data: {
        type: Object,
        required: true
      }
    },
    components: {
      Tooltip
    },
    methods: {
      url (data) {
        window.open('#/services/service/' + this.data.id)
      },
      view () {
        this.$router.push({name: 'Service', params: {id: this.data.id}})
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// RefundsTableButtons.vue?9b3f0526